import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { ToastrHelper } from '../../../helpers/toastr.helper';

import { TopPublication } from '../../../models/clubs/top-publication.model';
import { MemberApiService } from '../../../services/clubs/member.api.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-widget-publication',
    templateUrl: './widget-publication.component.html',
    styleUrls: ['widget-publication.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WidgetPublicationComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    public isLoading: boolean = true;
    public publications: TopPublication[] = [];

    constructor(private readonly toastrHelper: ToastrHelper, private router: Router, private readonly memberApiService: MemberApiService) { }

    public ngOnInit() {
        this.memberApiService.getTopPublications()
            .pipe(takeUntil(this.destroy$))
            .subscribe((publications) => {
                this.publications = publications;
                this.isLoading = false;
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public goToPublication(clubId: string, postId: string): void {
        this.router.navigate(['clubs', clubId, 'post', postId]);
    }
}
